/* unplugin-vue-components disabled */import script from "./Permission.vue?vue&type=script&setup=true&lang=js"
export * from "./Permission.vue?vue&type=script&setup=true&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=2603511e&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2603511e"]])

export default __exports__